import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Select, message, Popconfirm } from 'antd';
import axios from 'axios';
import API_BASE_URL from '../../config/api';

const { Option } = Select;

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [editingUser, setEditingUser] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);


    const fetchUsers = async () => {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_BASE_URL}/api/users`, {
            headers: { Authorization: `Bearer ${token}` },
        });

        setUsers(res.data);
    };

    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_BASE_URL}/api/users/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = { ...res.data, address: { province: res.data.province, district: res.data.district, subdistrict: res.data.subdistrict } };
            //console.log('Me:', data);
            setProfile(data);
            form.setFieldsValue(data);
        } catch (err) {
            message.error('ไม่สามารถโหลดข้อมูลโปรไฟล์');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProfile();
        fetchUsers();
    }, []);

    const openAddModal = () => {
        setEditingUser(null);
        form.resetFields();
        setIsModalOpen(true);
    };

    const openEditModal = (user) => {
        setEditingUser(user);
        form.setFieldsValue(user);
        setIsModalOpen(true);
    };

    const handleDelete = async (id) => {
        const token = localStorage.getItem('token');
        await axios.delete(`${API_BASE_URL}/api/users/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        message.success('ลบผู้ใช้เรียบร้อยแล้ว');
        fetchUsers();
    };

    const handleFinish = async () => {
        const values = await form.validateFields();
        const token = localStorage.getItem('token');
        try {
            if (editingUser) {
                await axios.put(`${API_BASE_URL}/api/users/${editingUser.id}`, values, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                message.success('แก้ไขผู้ใช้เรียบร้อยแล้ว');
            } else {
                await axios.post(`${API_BASE_URL}/api/users`, values, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                message.success('เพิ่มผู้ใช้เรียบร้อยแล้ว');
            }
            setIsModalOpen(false);
            fetchUsers();
        } catch (err) {
            message.error('เกิดข้อผิดพลาด');
        }
    };

    const columns = [
        { title: 'ชื่อผู้ใช้', dataIndex: 'username' },
        { title: 'ชื่อจริง', dataIndex: 'name' },
        { title: 'ระดับสิทธิ์', dataIndex: 'level' },
        {
            title: 'การจัดการ',
            render: (_, record) => (
                <>
                    {record.username === 'admin' ? null : (
                        <>
                            {profile.level === 'ภาค' && (
                                <>
                                    <Button type="link" onClick={() => openEditModal(record)}>แก้ไข</Button>
                                    <Popconfirm
                                        title="ยืนยันการลบผู้ใช้นี้?"
                                        onConfirm={() => handleDelete(record.id)}
                                    >
                                        <Button type="link" danger>ลบ</Button>
                                    </Popconfirm>
                                </>
                            )}

                        </>
                    )}

                </>
            ),
        },
    ];

    return (
        <>
            <h2>จัดการผู้ใช้</h2>

            {profile?.level === 'ภาค' && (
                <>
                    <Button type="primary" onClick={openAddModal} style={{ marginBottom: 16 }}>
                        เพิ่มผู้ใช้
                    </Button>
                    <Table columns={columns} dataSource={users} rowKey="id" />
                </>
            )}


            <Modal
                title={editingUser ? 'แก้ไขผู้ใช้' : 'เพิ่มผู้ใช้'}
                open={isModalOpen}
                onOk={handleFinish}
                okText='บันทึก'
                cancelText='ยกเลิก'
                onCancel={() => setIsModalOpen(false)}
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleFinish}>
                    <Form.Item name="username" label="ชื่อผู้ใช้" rules={[{ required: true }]}>
                        <Input readOnly={editingUser} />
                    </Form.Item>
                    {!editingUser && (
                        <>
                            <Form.Item name="password" label="รหัสผ่าน" rules={[{ required: true }]}>
                                <Input.Password />
                            </Form.Item>
                        </>
                    )}
                    <Form.Item name="name" label="ชื่อ-นามสกุล" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="role" label="ประเภทผู้ใช้" rules={[{ required: true }]}>
                        <Select>
                            <Option value="admin">ผู้ดูแลระบบ</Option>
                            <Option value="editor">นักเขียน</Option>
                            <Option value="viewer">ดูอย่างเดียว</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="level" label="ระดับสิทธิ์" rules={[{ required: true }]}>
                        <Select>
                            <Option value="ตำบล">เจ้าคณะตำบล</Option>
                            <Option value="อำเภอ">เจ้าคณะอำเภอ</Option>
                            <Option value="จังหวัด">เจ้าคณะจังหวัด</Option>
                            <Option value="ภาค">เจ้าคณะภาค</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="province" label="จังหวัด">
                        <Input />
                    </Form.Item>
                    <Form.Item name="district" label="อำเภอ">
                        <Input />
                    </Form.Item>
                    <Form.Item name="subdistrict" label="ตำบล">
                        <Input />
                    </Form.Item>
                    {/* <Form.Item>
                        <Button type="primary" htmlType="submit">
                            บันทึก
                        </Button>
                    </Form.Item> */}
                </Form>
            </Modal>
        </>
    );
};

export default UserManagement;
